import { render, staticRenderFns } from "./CtmDialog.vue?vue&type=template&id=027e5fc8&scoped=true&"
import script from "./CtmDialog.vue?vue&type=script&lang=js&"
export * from "./CtmDialog.vue?vue&type=script&lang=js&"
import style0 from "./CtmDialog.vue?vue&type=style&index=0&id=027e5fc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027e5fc8",
  null
  
)

export default component.exports